<div>
    <select [(ngModel)]="use.currentState.AllowedUsesId" [ngClass]="{
    'changed': use.isFieldChanged('AllowedUsesId'),
    'error': errorMessages?.length
    }" [disabled]="readOnly" (change)="handleManualChange(); handleValueChange()">
        <option *ngFor="let useAllowance of useAllowances" [ngValue]="useAllowance.Id">{{useAllowance.Label}}</option>
    </select>

    <calibration-set-table-field-attributes *ngIf="!hideAttributeButtons" [identifiers]="identifier"
        [showPopover]="true" [attributePopupTitleDetails]="attributePopupTitleDetails">
    </calibration-set-table-field-attributes>
</div>
